module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"color":"Farbe","details":"Details","icon":"Symbol","title":"Titel"},"en":{"color":"Color","details":"Details","icon":"Icon","title":"Title"}}')
  delete Component.options._Ctor
}
